import { type PopupProps } from "@client/layout/Popup/container";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import Component, { type MapProps } from "./component";
import { makeStyleSelector } from "./selectors";

type Props = PopupProps;
const makeMapStateToProps = () => {
  const styleSelector = makeStyleSelector();

  return (state: AppState, props: Props): MapProps => {
    return {
      ...props,
      style: styleSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
